<template>
  <div class="info">
    <div class="mask">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide :key="i" v-for="(item,i) in imageList">
          <div class="swiper-slide-imgbox" @click="closeSwiper">
            <img :src="item.url">
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import Swiper from 'swiper';
export default {
  name: "images",
  data() {
    return {
      imageList: [], // 图片展示
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        initialSlide: 0
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
    var _this = this;
    console.log(_this.$route.query)
    if (!_this.$route.query.imageList) {
      var thisParams = localStorage.getItem("thisParams");
    } else {
      localStorage.setItem("thisParams",_this.$route.params)
    }
    // 分享
    _this.wxshare();
  },
  methods: {
    /**
     * 关闭swiper
     */
    closeSwiper(){
      var _this = this;
    },
    /**
     * 分享
     */
    wxshare() {
      var _this = this;
      this.$axios
        .get("https://bandaoapi.bandaoapp.com/wxapi/wxConfig", {
          params: {
            url: encodeURIComponent(window.location.href.split("#")[0])
          }
        })
        .then(res => {
          var msg = res.data;
          if (msg.code != 200) {
            console.log("接口返回非200");
            return;
          }
          wx.config({
            appId: msg.result.appId,
            timestamp: msg.result.timestamp,
            nonceStr: msg.result.noncestr,
            signature: msg.result.signature,
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "onMenuShareWeibo",
              "hideMenuItems",
              "showMenuItems"
            ]
          });
          wx.ready(function() {
            var shareData = {
              title: "我们一起在青过年", // 分享标题
              desc: "说出你的故事和祝福", // 分享描述
              link: window.location.href.split("#")[0], // 分享链接
              imgUrl: "https://bd-config.oss-cn-qingdao.aliyuncs.com/share.png", // 分享图标
              success: function(res) {}
            };
            wx.updateAppMessageShareData(shareData);
            wx.updateTimelineShareData(shareData);
            wx.onMenuShareAppMessage(shareData);
            wx.onMenuShareTimeline(shareData);
            wx.onMenuShareQQ(shareData);
            wx.onMenuShareWeibo(shareData);
          });
          wx.error(function(error) {
            console.log("error");
            // alert(JSON.stringify(res))
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info_content p {
  margin: 0;
  padding: 0;
}

.info {
  width: 100%;
  position: relative;
  font: 14px/1.5em "PingFang SC", "Source Han Sans CN", "Lantinghei SC",
    "Open Sans", Arial, "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑",
    "STHeiti", "WenQuanYi Micro Hei", SimSun, sans-serif;
  color: #000;
}
/* globle */
body {
  margin: 0;
}
body {
  font: 14px/1.5em "PingFang SC", "Source Han Sans CN", "Lantinghei SC",
    "Open Sans", Arial, "Hiragino Sans GB", "Microsoft YaHei", "寰蒋闆呴粦",
    "STHeiti", "WenQuanYi Micro Hei", SimSun, sans-serif;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}
button,
input,
select,
textarea {
  font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
}
ul {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
h1,
h2,
h3,
h4 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
}
h2 {
  font-size: 16px;
  font-weight: 400;
  border-bottom: 1px solid #b9b9b9;
  margin-bottom: 10px;
  margin-top: 10px;
}
h2 span {
  float: left;
  padding: 0 6px 5px;
  border-bottom: 2px solid #ff605a;
}
h3 {
  font-size: 14px;
  font-weight: 400;
}
a {
  color: #ccc;
  text-decoration: none;
}
input,
select,
textarea,
button {
  -webkit-appearance: none;
  border-radius: 0;
  border: 1px solid #ccc;
}
.hide {
  display: none !important;
}
.cf:after {
  clear: both;
  content: " ";
  display: block;
  visibility: hidden;
}
.mask{
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  z-index: 9999;
}

/*swiper样式*/
.swiper-container{
  height: 100%;
}
.swiper-slide-imgbox{
  width: 100%;
  height: calc(100% - 30px);
  margin: 16px 0;
  overflow: auto;
  position: relative;
}
.swiper-slide-imgbox img{
  width: 100%;
  height: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
  .swiper-wrapper,.swiper-slide{
    height: 100%;
  }
  .swiper-slide{
    padding: 1px 0;
  }
</style>
